'use strict';
import angular from 'angular';
import './scripts/tasks.ctrls';
import './scripts/tasks.services';

import myTasksViewHtmlUrl from './views/myTasksView.html';
import myTasksHtmlUrl from './views/myTasks.html';
import adminTasksHtmlUrl from'./views/adminTasks.html';
import addAdminTasksHtmlUrl from './views/addAdminTasks.html';


angular.module('tasks', [
    'tasks.ctrls',
    'tasks.services'
])

    .config(['$stateProvider', function($stateProvider) {
        $stateProvider
            .state('viewClientTask', {
                parent: 'layout',
                url: '/items/viewClient/:clientId/myTasks/:taskId?fromPage',
                templateUrl: myTasksViewHtmlUrl,
                controller: 'MyTasksViewController'
            })
            .state('viewOrderTask', {
                parent: 'layout',
                url: '/items/viewOrder/:orderId/myTasks/:taskId?fromPage',
                templateUrl: myTasksViewHtmlUrl,
                controller: 'MyTasksViewController'
            })
            .state('viewLineItemTask', {
                parent: 'layout',
                url: '/items/viewLineItem/:lineItemId/myTasks/:taskId?fromPage',
                templateUrl: myTasksViewHtmlUrl,
                controller: 'MyTasksViewController'
            })
            .state('viewFlightTask', {
                parent: 'layout',
                url: '/items/viewFlight/:flightId/:lineItemId/myTasks/:taskId?fromPage',
                templateUrl: myTasksViewHtmlUrl,
                controller: 'MyTasksViewController'
            })
            .state('myTasksView', {
                parent: 'layout',
                url: '/items/myTasks/:taskId?myQueues&fromPage',
                templateUrl: myTasksViewHtmlUrl,
                controller: 'MyTasksViewController'
            })
            .state('myTasks', {
                parent: 'layout',
                url: '/items/myTasks',
                templateUrl: myTasksHtmlUrl,
                controller: 'MyTasksController'
            })
            .state('adminTasks', {
                parent: 'layout',
                url: '/admin/tasks',
                templateUrl: adminTasksHtmlUrl,
                controller: 'AdminTasksController',
                params: {
                    message: null
                }
            })
            .state('addAdminTasks', {
                parent: 'layout',
                url: '/admin/tasks/add',
                templateUrl: addAdminTasksHtmlUrl,
                controller: 'AddAdminTasksController',
                params: {
                    comeFrom: null,
                    'taskInfo': null,
                }
            })
            .state('editAdminTasks', {
                parent: 'layout',
                url: '/admin/tasks/edit/:id',
                templateUrl: addAdminTasksHtmlUrl,
                controller: 'AddAdminTasksController',
                params: {
                    comeFrom: null,
                    'taskInfo': null,
                }
            })
    }]);